import React, { useState } from "react";
import Checkbox from "../../../../components/Checkbox/Checkbox";
import TextButton from "../../../../components/Buttons/TextButton/TextButton";
import MunicipalityModal from "./MunicipalityModal/MunicipalityModal";
import "./municipalityDropdown.css";
import CloseButton from "../../../../components/Buttons/CloseButton/closeButton";
import ZoneDropdown from "../ZoneDropdown/ZoneDropdown";

export default function MunicipalityDropdown({
  selectedMunicipality,
  setSelectedMunicipality,
  selectedZones,
  setSelectedZones,
  closeMunicipalityDropdown,
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const bigCities = ["stockholm", "göteborg", "malmö"];

  const selectedSingleMunicipality = selectedMunicipality.length === 1 ? selectedMunicipality[0] : null;

  const shouldShowZones = selectedMunicipality && bigCities.includes(selectedSingleMunicipality);

  const handleMunicipalityChange = (municipality) => {
    if (selectedMunicipality.includes(municipality)) {
      setSelectedMunicipality(selectedMunicipality.filter((item) => item !== municipality));
      setSelectedZones([]); 
    } else {
      setSelectedMunicipality([...selectedMunicipality, municipality]);
      setSelectedZones([]); 
    }
  };

  const handleClearButtonClick = () => {
    setSelectedMunicipality([]);
    setSelectedZones([]);
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  return (
    <div className={`municipality-dropdown`}>
      <div className="space-dropdown-header">
        <p className="municipality-top-text">Var?</p>
        <CloseButton onClick={closeMunicipalityDropdown} />
      </div>
      <div className="municipality-content-wrapper">
        <div className="municipality-checkbox-wrapper">
          <Checkbox
            label="Stockholm"
            isChecked={selectedMunicipality.includes("stockholm")}
            onChange={() => handleMunicipalityChange("stockholm")}
          />
          <Checkbox
            label="Uppsala"
            isChecked={selectedMunicipality.includes("uppsala")}
            onChange={() => handleMunicipalityChange("uppsala")}
          />
          <Checkbox
            label="Göteborg"
            isChecked={selectedMunicipality.includes("göteborg")}
            onChange={() => handleMunicipalityChange("göteborg")}
          />
          <Checkbox
            label="Malmö"
            isChecked={selectedMunicipality.includes("malmö")}
            onChange={() => handleMunicipalityChange("malmö")}
          />
        </div>
        <button className="municipality-dropdown-show-more" onClick={handleOpenModal}>
          Visa fler kommuner
        </button>
        {isModalOpen && (
          <MunicipalityModal
            isOpen={isModalOpen}
            onRequestClose={() => setIsModalOpen(false)}
            selectedMunicipality={selectedMunicipality}
            setSelectedMunicipality={setSelectedMunicipality}
          />
        )}
        {shouldShowZones && (
            <ZoneDropdown
              municipality={selectedSingleMunicipality}
              selectedZones={selectedZones}
              setSelectedZones={setSelectedZones}
            />
          )}
      </div>
      <hr />
      <div className="municipalitys-button-wrapper">
        <TextButton label="Rensa" size="sm" onClick={handleClearButtonClick} />
      </div>
    </div>
  );
}
